// Libs
import React from 'react';
// Utils
import { formatDate } from 'utils/libs/dateFormats';
import DataFieldManagerUtils from '../DataFieldManagerUtils';
// Actions
import { sendToast } from 'screens/Dashboard/actions';
// Hooks
import { useDispatch } from 'react-redux';
// Components
import { Span } from 'components';
import { isReadOnlyFieldClickable } from './OnlyReadField.utils';

const { DATETIME, DATE, BOOLEAN } = DataFieldManagerUtils.getFieldTypes();

export const getUIValueProp = field => {
	const levels = {
		shallow: field.uiValueProp,
		deep: field[field.uiValueProp],
	};
	return levels[field.uiValuePropLevel] || levels.shallow;
};

export const getValueFromRowData = ({ field, rowData }) => {
	return field.uiValueProp
		? rowData[getUIValueProp(field)]
		: rowData[field.name] || rowData[field.id];
};

const checkTimezone = ({ value, field, profile }) => {
	if (field.type !== DATETIME && field.type !== DATE) return value;
	if (!field.dateFormat && !profile?.organization?.tz) return value;

	return formatDate(value, profile, field.dateFormat);
};

const formatBooleanValue = ({ value, field }) => {
	if (field.type !== BOOLEAN) return value;
	return value === true || value === 'true' ? 'Si' : 'No';
};

const OnlyReadField = ({
	rowData,
	field,
	profile,
	emphasis,
	hoverable,
	isCopyValue,
}) => {
	let value = getValueFromRowData({ field, rowData });
	if (field.type === BOOLEAN) {
		value = formatBooleanValue({ value, field });
	} else if (value) {
		value = checkTimezone({ value, field, profile });
	}
	// TODO: fix isCopyValue

	const dispatch = useDispatch();
	const sendMessage = ({ message, type = 'success' }) => {
		dispatch(
			sendToast({
				message,
				type,
				duration: 2,
			}),
		);
	};

	const copyValue = () => {
		navigator.clipboard.writeText(value);
		sendMessage({ message: 'Valor Copiado!' });
	};
	const isClickable = isReadOnlyFieldClickable({ field, rowData });
	const handleClick = event => {
		if (isClickable) {
			event.stopPropagation();
			field.onClick(rowData, event);
			return;
		}
		if (isCopyValue) copyValue();
	};

	return (
		<Span
			hoverable={hoverable || isClickable}
			emphasis={emphasis}
			cursor={isClickable ? 'pointer' : undefined}
			maxHeight='200px'
			overflow='auto'
			onClick={isClickable || isCopyValue ? handleClick : undefined}
		>
			{value}
		</Span>
	);
};

export default OnlyReadField;
